// // Copyright (c) Hamilton Manufacturing Corp.

import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Loader } from "@googlemaps/js-api-loader"
import styled from 'styled-components';
import { useGlobalState } from './globalState/GlobalStateProvider';
import user from '../../assets/images/user.png'
import Loading from './Loading';

const StyleWrapper = styled.div`
    display: flex;
    align-items: center;
`
const Map = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 0.25rem;

    display: ${({ loaded }) => !loaded ? 'none' : ''};
`

const GoogleMap = ({ config, additionalOptions = {}, markerClick, ...props }) => {
    const { state: {
        active_user,
    } } = useGlobalState();

    const APIKey = process.env.REACT_APP_GOOGLE_API_KEY;

    const loader = new Loader({
        apiKey: APIKey,
        version: "weekly",
    });

    const [Gmap, setGMap] = useState(null);

    useLayoutEffect(() => {
        // setMarks(config.markers.map(e => { return { lat: e.latitude, lng: e.longitude, location: e } }))
    }, [config])

    useEffect(() => {
        const center = config.center.lat && config.center.lng ? config.center : null;
        const mapOptions = {
            center: center || {
                lat: config.markers.reduce((a, b) => a + b.latitude, 0) / config.markers.length,
                lng: config.markers.reduce((a, b) => a + b.longitude, 0) / config.markers.length,
            },
            zoom: config.zoom || 11,
            ...additionalOptions,
        }

        loader
            .load()
            .then(google => {
                let map = new google.maps.Map(document.getElementById('map'), mapOptions)
                config.markers.forEach(e => {
                    const marker = new google.maps.Marker({
                        position: {
                            lat: e.latitude,
                            lng: e.longitude
                        },
                        map,
                        animation: google.maps.Animation.DROP,
                        title: e.name,
                        id: `${e.name}-marker`
                    });
                    google.maps.event.addListener(marker, 'click', function () {
                        map.panTo({
                            lat: e.latitude,
                            lng: e.longitude
                        });
                        markerClick(e)
                    });
                });

                const controlDiv = document.createElement('div');
                const firstChild = document.createElement('button');
                firstChild.style.backgroundColor = '#fff';
                firstChild.style.border = 'none';
                firstChild.style.outline = 'none';
                firstChild.style.width = '28px';
                firstChild.style.height = '28px';
                firstChild.style.borderRadius = '2px';
                firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
                firstChild.style.cursor = 'pointer';
                firstChild.style.margin = '10px';
                firstChild.style.padding = '0px';
                firstChild.title = 'Your Location';
                controlDiv.appendChild(firstChild);

                const secondChild = document.createElement('div');
                secondChild.style.margin = '5px';
                secondChild.style.width = '18px';
                secondChild.style.height = '18px';
                secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';
                secondChild.style.backgroundSize = '180px 18px';
                secondChild.style.backgroundPosition = '0px 0px';
                secondChild.style.backgroundRepeat = 'no-repeat';
                secondChild.id = 'you_location_img';
                firstChild.appendChild(secondChild);

                firstChild.addEventListener('click', function () {
                    map.panTo({
                        lat: active_user.location?.lat || mapOptions.center.lat,
                        lng: active_user.location?.lng || mapOptions.center.lng
                    });
                    map.setZoom(mapOptions.zoom);
                })
                map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);

                if (active_user.location) {
                    new google.maps.Marker({
                        position: {
                            lat: active_user.location.lat,
                            lng: active_user.location.lng
                        },
                        map,
                        icon: {
                            url: user,
                            scaledSize: new google.maps.Size(35, 35)
                        },
                        animation: google.maps.Animation.DROP,
                        id: `userLoc-marker`
                    });
                }
                setGMap(map)
            })
            .catch(e => {
                console.log('ERROR')
            });
    }, [active_user.location])

    useEffect(() => {
        if (!Gmap) return;
        Gmap.panTo(config.center);
    }, [config.center])

    useEffect(() => {
        if (!Gmap) return;
        Gmap.setZoom(config.zoom);
    }, [config.zoom])

    return (
        <StyleWrapper {...props} data-draggable={true}>
            {!Gmap ? <Loading /> : null}
            <Map key={'googleMap'} id='map' loaded={Gmap} />
        </StyleWrapper>
    );
}

export default GoogleMap;